import { ref } from 'vue'
import { defineStore } from 'pinia'
import  axios  from "axios";

const default_end = new Date()
const default_start = new Date()
default_start.setTime(default_start.getTime() - 3600 * 1000 * 24 * 555)

const default_start_string = `${default_start.getFullYear()}-${default_start.getMonth() + 1}-${default_start.getDate()}`;
const default_end_string = `${default_end.getFullYear()}-${default_end.getMonth() + 1}-${default_end.getDate()}`;

export const useMailLogStore = defineStore('maillogs', {


  state: () => ({
      mails: [],
      columns: [],
      dates: [default_start_string, default_end_string],
      selectedItems : [],
      pageSize: 10,
      currentPage: 1,
      totalRows:20,
      isLoading:false,
      filterRelation: 'OR',
      filters:[],
  }),
  getters: {
    disableDelete: (state) => {
      return state.selectedItems.length? false: true;
    }, 
    disableSingleSelectActions: (state) => {
      return (state.selectedItems.length && state.selectedItems.length == 1 )? false: true;
    },
    singleMailSelectedData: (state) => {
      return state.mails.filter((mail) => mail.id === state.selectedItems[0])[0]
    }

  },
  actions: { 
    fetchLogs(){
      
      // Return if date is not set
      if(this.dates.length < 1){
        return;
      }

      this.isLoading = true;

      const that = this;
      const { rest_url } = WmlGlobalVar;

      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-WP-Nonce': WmlGlobalVar.nonce,
        }
      }

      axios.post(`${rest_url}wml/v1/wml_logs`, {
        startDate: this.dates[0],
        endDate: this.dates[1],
        pageIndex: this.currentPage - 1,
        pageSize: this.pageSize,
        filterRelation: this.filterRelation,
        filter: this.filters

      }, config)
      .then(function (response) {
        that.mails = response.data.data;
        that.columns = response.data.columns
        that.totalRows = Number(response.data.totalRows)
        that.isLoading = false;
      })
      .catch(function (error) {
        this.isLoading = false;
        console.log(error);
      })
    },
    deleteLog(){

      const that = this;
      const { rest_url } = WmlGlobalVar;

      const config = {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-WP-Nonce': WmlGlobalVar.nonce,
        }
      }

      axios.post(`${rest_url}wml/v1/wml_logs/delete`, {
        ...this.selectedItems
      }, config)
      .then(function (response) {
        that.fetchLogs();
      })
      .catch(function (error) {
        this.isLoading = false;
        console.log(error);
      })
    },
    async forwardEmail(data){
      const that = this;
      const { rest_url } = WmlGlobalVar;

      const config = {
        headers: {
          'X-WP-Nonce': WmlGlobalVar.nonce,
        }
      }
      
      await axios.post(`${rest_url}wml/v1/wml_logs/send_mail`, 
        data,config
      )
      .then(function (response) {
        that.fetchLogs();
      })
      .catch(function (error) {
        this.isLoading = false;
        console.log(error);
      })
    },
    setFilters(data){
      this.filters = data;
    }
  }
})
